"use client";
import React, { useRef, useEffect, useState } from "react";
import { Canvas, useThree } from "@react-three/fiber";
import { OrbitControls, useTexture } from "@react-three/drei";
import * as THREE from "three";

const Scene = ({ background, image }: { background: boolean, image: string }) => {
  const requestRef = useRef<number>();
  const previousTimeRef = useRef<number>();
  const animationLoopRef = useRef<number>(0);

  let lat: number = 0;
  let lon: number = 0;
  let phi: number = 0;
  let theta: number = 0;
  let rotatespeed: number = 0.05;

  const animate = (time: number) => {
    if (previousTimeRef.current !== undefined) {
      const deltaTime = time - previousTimeRef.current;

      lat = Math.max(-85, Math.min(85, lat));
      phi = THREE.MathUtils.degToRad(90 - lat);
      theta = THREE.MathUtils.degToRad(
        lon > 360 ? (lon = 0 + rotatespeed) : (lon += rotatespeed)
      );
      camera.position.x = 100 * Math.sin(phi) * Math.cos(theta);
      camera.position.y = 100 * Math.cos(phi);
      camera.position.z = 100 * Math.sin(phi) * Math.sin(theta);
      camera.lookAt(scene.position);

      // camera.updateProjectionMatrix();
    }
    previousTimeRef.current = time;
    requestRef.current = requestAnimationFrame(animate);
    if(!background) {
      animationLoopRef.current++;
      if(animationLoopRef.current > 100)
      {
        cancelAnimationFrame(requestRef.current);
      }
    }
  };

  useEffect(() => {
    if(!background)
    {
      document.addEventListener("mousedown", e => {
        const target = e.target as HTMLElement;
        target.className = "hand-grabbing";
      })
      document.addEventListener("mouseup", e => {
        const target = e.target as HTMLElement;
        target.className = "hand-grab";
      })      
    }  
  }, [background]);

  const { camera, gl, scene } = useThree();

  useEffect(() => {
    const texture = new THREE.TextureLoader().load(
      image,
      () => {
        render();
      }
    );
    texture.mapping = THREE.EquirectangularReflectionMapping;
    // const texture = new THREE.CanvasTexture(textureImageBitmap)
    texture.colorSpace = THREE.SRGBColorSpace; //fix washed out color
    scene.background = texture;
  }, [scene, camera, image]);

  useEffect(() => {
    animationLoopRef.current=0;
    requestAnimationFrame(animate);     
  }, [image]);

  const render = () => {
    gl.render(scene, camera);
  };

  return (
    <>
      {!background && <OrbitControls onChange={render} /> }
      {render()}
    </>
  );
};

const SphericalRender = ({ background, image }: { background: boolean, image: string }) => {

  return (
    <div className="scene-container">
      <Canvas className={`${!background && "hand-grab"}`} camera={{ fov: 90, position: [0, 0, 0.01], near: 20, far: 100 }}>
        <Scene background={background} image={image} />
      </Canvas>
    </div>
  );
};

export default SphericalRender;
